import AndroidNativeCaller from 'fk-cp-shared/components/android/NativeCaller';
import IOSNativeCaller from 'fk-cp-shared/components/ios/NativeCaller';
import UAHelper from 'fk-cp-shared/utils/UAHelper';
import AppEnvironmentHelper from 'fk-cp-shared/utils/AppEnvironmentHelper';

if (__DEV__ && window.appEnvironment) {
	window.appEnvironment.isLoggedIn = true;
}

class userLoginStatus {
	check() {
		return new Promise(function (resolve, reject) {
			let nativeCallerPromise = null;
			if (UAHelper._isAndroid() && AndroidNativeCaller.bridgeAvailable()) {
				nativeCallerPromise = AndroidNativeCaller.run('getAuthParams');
			} else if (UAHelper._isIOS() && IOSNativeCaller.bridgeAvailable()) {
				nativeCallerPromise = IOSNativeCaller.run('getAuthParams');
			} else if (UAHelper._isMsite()) {
				nativeCallerPromise = Promise.resolve(JSON.stringify(AppEnvironmentHelper.getAuthParams()));
			}

			nativeCallerPromise.then(
				data => {
					data = JSON.parse(data);

					if (UAHelper._isAndroid()) {
						resolve(typeof data.loggedIn === 'undefined' ? null : !!data.loggedIn);
					}

					if (UAHelper._isIOS()) {
						resolve(typeof data.isLoggedIn === 'undefined' ? null : !!data.isLoggedIn);
					}

					if (UAHelper._isMsite()) {
						if (window.appEnvironment) {
							resolve(
								typeof window.appEnvironment.isLoggedIn === 'undefined'
									? false
									: !!window.appEnvironment.isLoggedIn
							);
						}
					}
				},

				error => {
					reject(error);
				}
			);
		});
	}
}

export default new userLoginStatus();
